import { Message, IMessage } from "./Message";

export interface IPrivacyAndComplianceMessage extends IMessage {

    $type: string,
    privacy : ILinkDescription;
    compliance: ILinkDescription;

    items? :  ILinkDescription[];

}

export interface ILinkDescription {


    title:string;
    badge?:string;
    link: string;
    description: string;
    smallPrint?: string;

}


export const LinkDescription = (props:ILinkDescription) => {

    return  <a href={props.link} target="_blank" className="list-group-item list-group-item-action">
    <div className="d-flex w-100 justify-content-between">
      <h6 className="mb-1">{props.title}</h6>
      { props.badge && <span className="badge text-bg-light rounded-pill">{props.badge}</span>}
    </div>
    <p className="mb-1">{props.description}</p>
    {props.smallPrint && <small>{ props.smallPrint }</small>}
  </a>

}


export const PrivacyAndComplianceDefaults : IPrivacyAndComplianceMessage = {

    $type:"PrivacyAndComplianceMessage",
    Identifier:"PrivacyAndCompliance", 
    IsInbound:false,
    Channel:null,
    To:null,
    Timestamp:(new Date()),
    From:null,
    Delay:0,


    privacy: {
        title: "Privacy & Security",
        badge: "ISO 27701, ISO 27001",
        link: "https://miles-research.com/privacy/",
        description:"Hier vindt u informatie met betrekking tot Privacy.",
        
    },
    compliance: {
        title: "Over Miles Research",
        badge: "Transparantie",
        link: "https://miles-research.com/over-ons/",
        description:"Hier vindt u meer informatie over Miles Research en wie wij zijn."
    }

};


export const PrivacyAndComplianceMessage = (props: IPrivacyAndComplianceMessage) => {



    return <Message {...props} >
    
        <div className="list-group">
        
            <LinkDescription {...props.privacy}/>
            <LinkDescription {...props.compliance}/>

            { props.items && props.items.map( (item,idx) => <LinkDescription key={idx} {...item}/> ) }

        </div>
    
    </Message>;

}